var DOCS = 'see documentation at: https://github.com/mhoffmann/react-hook-breakpoints';
export var ERRORS = {
    NO_BREAKPOINTS: "react-breakpoints requires you to pass an object of breakpoints, ".concat(DOCS),
    NOT_OBJECT: "react-breakpoints requires you to pass an object of breakpoints, ".concat(DOCS),
    EMPTY_OBJECT: "react-breakpoints requires you to pass an object of breakpoints, ".concat(DOCS),
};
//# sourceMappingURL=messages.js.map